<template lang="html">
<v-container fluid>
  <!-- TODO: what does this router-view do?  -->
  <router-view />
  <TFlex>
    <h2>{{$t("Account.AccountSettings.Status")}}</h2>
  </TFlex>
  <TFlex justify_content="start" :style="$vuetify.breakpoint.smAndDown ? 'flex-direction:column' : 'flex-direction:row'" wrap="wrap">
    <StandardTextCard
      :style="`min-width:33%; ${ $vuetify.breakpoint.smAndDown ? 'max-width:100%': 'max-width:33%' }; flex-shrink: 0`"
      :height="$vuetify.breakpoint.smAndDown ? '500px' : '720px'"
      :name="$t('Account.AccountSettings.InvitedUser.Header')"
      :clickable="false"
    >
      <template #info>
        <!-- As an INVITED.user you can work on projects you have been invited to as well as create your own WORK.packages and Sequences using the Workbench. -->
        <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[0]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[1]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[2]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[3]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[4]')" :readonly="true" />
        <StandardTextfield class="mt-2 cursor-pointer" color="brown darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.InvitedUser.Values[5]')" :readonly="true" />
      </template>
      <template #bottom-info>
        <v-alert width="100%" :height="$vuetify.breakpoint.smAndDown ? '100px' : '80px'" border="top" color="brown darken-1" dark class="mb-10">
          {{$t('Account.AccountSettings.InvitedUser.DescribtionBox[0]')}} <br>
          {{$t('Account.AccountSettings.InvitedUser.DescribtionBox[1]')}}
        </v-alert>
      </template>
      <template #actions>
        <v-icon :color="hasHigherAccStatusThen('Invited User') ? 'green' : 'grey'">check_circle_outline</v-icon>
      </template>
    </StandardTextCard>
    <StandardTextCard
      :style="`min-width:33%; ${ $vuetify.breakpoint.smAndDown ? 'max-width:100%': 'max-width:33%' }; flex-shrink: 0`"
      :height="$vuetify.breakpoint.smAndDown ? '650px' : '720px'"
      :name="$t('Account.AccountSettings.FullUser.Header')"
      :clickable="false"
    >
      <template #info>
        <!-- As a FULL.user you are enjoying all features of the INVITED.user account. On top of that you are able to create your own projects and invite new as well as existing users to collaborate on them. Further you can contribute to the TAKT.community by uploading your WORK.packages and Sequences. -->
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[0]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[1]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[2]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[3]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[4]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[5]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[6]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[7]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[8]')" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.FullUser.Values[9]')" :readonly="true" />
      </template>
      <template #bottom-info>
        <v-alert width="100%" :height="$vuetify.breakpoint.smAndDown ? '100px' : '80px'" border="top" color="blue-grey darken-1" dark class="mb-10">
          {{$t('Account.AccountSettings.FullUser.DescribtionBox[0]')}} <br>
          {{$t('Account.AccountSettings.FullUser.DescribtionBox[1]')}}
        </v-alert>
      </template>
      <template #actions>
        <v-btn color="blue" text :disabled="getUser.account_status !== 'Invited User' || getUserUpgrades.id !== -1" :to="{ name: 'AccountSettingsUserUpgradeFullUser'}">Upgrade</v-btn>
        <v-icon :color="hasHigherAccStatusThen('Full User') ? 'green' : 'grey'">check_circle_outline</v-icon>
        <v-icon color="orange" v-if="getUserUpgrades.id !== -1 && getUserUpgrades.requested_role.name === 'Full User'">hourglass_empty</v-icon>
      </template>
    </StandardTextCard>
    <StandardTextCard
      :style="`min-width:33%; ${ $vuetify.breakpoint.smAndDown ? 'max-width:100%': 'max-width:33%' }; flex-shrink: 0`"
      :height="$vuetify.breakpoint.smAndDown ? '760px' : '720px'"
      :name="$t('Account.AccountSettings.ProUser.Header')"
      :clickable="false"
    >
    <template #info>
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[0]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[1]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[2]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[3]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[4]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[5]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[6]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[7]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[8]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[9]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[10]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[11]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProUser.Values[12]')" :readonly="true" />
    </template>
    <template #bottom-info>
      <v-alert width="100%" :height="$vuetify.breakpoint.smAndDown ? '100px' : '80px'" border="top" color="amber darken-3" dark class="mb-10">
        {{$t('Account.AccountSettings.ProUser.DescribtionBox[0]')}} <br>
        {{$t('Account.AccountSettings.ProUser.DescribtionBox[1]')}} <small>{{$t('Account.AccountSettings.ProUser.DescribtionBox[2]')}}</small> <br>
      </v-alert>
    </template>
    <template #actions>
      <div class="pro-user-buttons">
        <v-btn color="blue" text
          :disabled="getUser.pro_user_single || getUser.pro_user_company ||  getUserUpgrades.id !== -1"
          :to="{ name: 'AccountSettingsUserUpgradeProUser', params: { type: 'Single'}}">
          Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'SINGLE' : 'S'}})
        </v-btn>
        <v-btn color="blue" text
          :disabled="getUser.pro_user_company ||  getUserUpgrades.id !== -1"
          :to="{ name: 'AccountSettingsUserUpgradeProUser', params: { type: 'Business'}}">
          Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'COMPANY' : 'C'}})
        </v-btn>
        <v-icon :color="hasHigherAccStatusThen('Pro User') ? 'green' : 'grey'">check_circle_outline</v-icon>
        <v-icon color="orange" v-if="showProUserIsRequested()">hourglass_empty</v-icon>
      </div>
    </template>
    </StandardTextCard>
    <StandardTextCard
      :style="`min-width:33%; ${ $vuetify.breakpoint.smAndDown ? 'max-width:100%': 'max-width:33%' }; flex-shrink: 0`"
      :height="$vuetify.breakpoint.smAndDown ? '460px' : '720px'"
      :name="$t('Account.AccountSettings.ProIntegration.Header')"
      :clickable="false"
    >
    <template #info>
      <StandardTextfield class="mt-2" color="teal darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProIntegration.Values[0]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="teal darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProIntegration.Values[1]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="teal darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProIntegration.Values[2]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="teal darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProIntegration.Values[3]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="teal darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProIntegration.Values[4]')" :readonly="true" />
    </template>
    <template #bottom-info>
      <v-alert width="100%" :height="$vuetify.breakpoint.smAndDown ? '100px' : '80px'" border="top" color="teal darken-3" dark class="mb-10">
        {{$t('Account.AccountSettings.ProIntegration.DescribtionBox[0]')}}<br>
        <small>{{$t('Account.AccountSettings.ProIntegration.DescribtionBox[1]')}}</small>
        <small class="ml-3">{{$t('Account.AccountSettings.ProIntegration.DescribtionBox[2]')}}</small>
      </v-alert>
    </template>
    <template #actions>
      <div class="pro-user-buttons">
        <v-btn color="blue" text
          :disabled="getUser.pro_user_integration ||  getUserUpgrades.id !== -1"
          :to="{ name: 'AccountSettingsUserUpgradeProUserIntegration'}">
          Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'INTEGRATION' : 'I'}})
        </v-btn>
        <v-icon :color="hasHigherAccStatusThen('Pro User') ? 'green' : 'grey'">check_circle_outline</v-icon>
        <v-icon color="orange" v-if="showProUserIsRequested()">hourglass_empty</v-icon>
      </div>
    </template>
    </StandardTextCard>
    <StandardTextCard
      :style="`min-width:33%; ${ $vuetify.breakpoint.smAndDown ? 'max-width:100%': 'max-width:33%' }; flex-shrink: 0`"
      :height="$vuetify.breakpoint.smAndDown ? '460px' : '720px'"
      :name="$t('Account.AccountSettings.ProBIM.Header')"
      :clickable="false"
    >
    <template #info>
      <StandardTextfield class="mt-2" color="cyan darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProBIM.Values[0]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="cyan darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProBIM.Values[1]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="cyan darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProBIM.Values[2]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="cyan darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProBIM.Values[3]')" :readonly="true" />
      <StandardTextfield class="mt-2" color="cyan darken-3" textcolor="snow" icon="info" :value="$t('Account.AccountSettings.ProBIM.Values[4]')" :readonly="true" />
    </template>
    <template #bottom-info>
      <v-alert width="100%" :height="$vuetify.breakpoint.smAndDown ? '100px' : '80px'" border="top" color="cyan darken-3" dark class="mb-10">
        {{$t('Account.AccountSettings.ProBIM.DescribtionBox[0]')}}
      </v-alert>
    </template>
    <template #actions>
      <div class="pro-user-buttons">

        <!-- <v-icon :color="hasHigherAccStatusThen('Pro User') ? 'green' : 'grey'">check_circle_outline</v-icon> -->
        <!-- <v-icon color="orange" v-if="showProUserIsRequested()">hourglass_empty</v-icon> -->
      </div>
    </template>
    </StandardTextCard>
  </TFlex>
    <TFlex :style="$vuetify.breakpoint.smAndDown ? 'flex-direction:column' : 'flex-direction:row'">
      <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%': 'width: 33%'">
        <h2>{{$t('Account.AccountSettings.AccountStatus.Header')}}</h2>
        <v-list>
          <v-subheader>{{$t('Account.AccountSettings.AccountStatus.YourRoles')}}</v-subheader>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="hasHigherAccStatusThen('Invited User') ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[0]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="hasHigherAccStatusThen('Full User') ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[1]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="getUser.pro_user_single ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[2]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="getUser.pro_user_company ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[3]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="getUser.pro_user_integration ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[4]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="getUser.pro_user_bim ? 'green' : 'grey'">check_circle_outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('Account.AccountSettings.AccountStatus.Roles[5]')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%': 'width: 33%'">
        <h2>{{$t('Account.AccountSettings.AccountPassword.Header')}}</h2>
        <v-text-field v-model="old_password" filled clear-icon="clear"
        :label="$t('Account.AccountSettings.AccountPassword.Old')" type="password" :rules="[rules.required]">
      </v-text-field>
      <v-text-field v-model="new_password" filled clear-icon="clear"
      :label="$t('Account.AccountSettings.AccountPassword.New')" type="password" :rules="[rules.required, rules.min8, hasNumber, hasSpecialCharacter]">
    </v-text-field>
    {{getAccountSettingsStatus}}
    <br>
    <v-btn :style="$vuetify.breakpoint.smAndDown ? 'margin-bottom: 50px;' : ''" :disabled="!passwordIsValid" @click="changePassword(
      {
        id: $store.state.Auth.current_user.id,
        passwords: {
          old_password: old_password,
          new_password: new_password
        }
      }
      )" color="lighten-1">{{$t('Account.AccountSettings.AccountPassword.Change')}}</v-btn>
      </div>
      <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%': 'width: 33%'">
        <v-card height="100%">
          <v-card-title>Email Notification Settings</v-card-title>
          <v-content class="pt-1">
            <StandardSwitch class ="mb-3" :value="email_project_invitations" label="email_notifications_project_invitations"
            @changeValue="updateUObject({
                url: [
                  {users: getUser.id},
                ],
                update: {
                  email_project_invitations: !email_project_invitations
                }
              }).then(() => {
                email_project_invitations = !email_project_invitations
              })"/>
            <StandardSwitch class ="mb-3" :value="email_project_role_changes" label="email_notifications_project_role_changes" 
            @changeValue="updateUObject({
                url: [
                  {users: getUser.id},
                ],
                update: {
                  email_project_role_changes: !email_project_role_changes
                }
              }).then(() => {
                email_project_role_changes = !email_project_role_changes
              })" />
            <!-- commented out until backend can do this -->
            <!-- <StandardSwitch class ="mb-3" :value="email_ifc_upload" label="email_notifications_ifc_upload" 
            @changeValue="updateUObject({
                url: [
                  {users: getUser.id},
                ],
                update: {
                  email_ifc_upload: !email_ifc_upload
                }
              }).then(() => {
                email_ifc_upload = !email_ifc_upload
              })" /> -->
          </v-content>
        </v-card>
      </div>
  </TFlex>

</v-container>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'
import TFlex from '@/components/Taktify/TFlex.component.vue'
import store from '@/store/index'
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountSettings',
  components: {
    StandardTextCard, StandardTextfield, TFlex,
    StandardSwitch,
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestUserUpgrades').then(res => next(res));
  },
  data: function() {
    return {
      old_password: '',
      new_password: '',
      rules: {
        required: value => !!value || 'Required.',
        min8: v => v.length >= 8 || 'Min 8 characters'
      },
      test: false,
      email_project_invitations: false,
      email_project_role_changes: false,
      email_ifc_upload:false,
    }
  },
  created(){
    this.email_project_invitations = this.getUser.email_project_invitations
    this.email_project_role_changes = this.getUser.email_project_role_changes
    this.email_ifc_upload = this.getUser.email_ifc_upload
  },
  computed: {
    ...mapGetters('View', [
      'getAccountSettingsStatus'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('User', [
      'getUserUpgrades'
    ]),
    passwordIsValid(){
      if (this.hasSpecialCharacter(this.new_password) & this.hasNumber(this.new_password) & this.new_password.length >= 8) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions('User', [
      'changePassword'
    ]),
    ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
    ]),
    test_ultra(){
      this.updateUObject({
                      url: [
                        {users: this.getUser.id},
                      ],
                      update: {
                        email_project_invitations: false
                      }
                  })
    },
    showProUserIsRequested(){
      return this.getUserUpgrades.id !== -1 && (
        this.getUserUpgrades.requested_role.name === 'Pro User' ||
        this.getUserUpgrades.requested_role.name === 'Pro User Integration' ||
        this.getUserUpgrades.requested_role.name === 'Pro User Business' ||
        this.getUserUpgrades.requested_role.name === 'Pro User BI'
      );
    },
    hasNumber(value) {
      var matches = /\d/.test(value);
      if (matches == true) {
        return true;
      } else {
        return 'password has to contain a number.';
      }
    },
    hasSpecialCharacter(value){
      var string = "^ $ * . [ ] { } ( ) ? ! @ # % & : ; | _ ~";
      var format = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/;
      var matches = format.test(value)
      if (matches == true) {
        return true;
      } else {
        return "password has to contain a special Charakters:" + string;
      }
    },
    hasHigherAccStatusThen(role){
      let curr_role = this.getUser.account_status;
      switch (role) {
        case 'Invited User':
          if (curr_role === 'Invited User' || curr_role === 'Full User' || curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        case 'Full User':
          if (curr_role === 'Full User' || curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        case 'Pro User':
          if (curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        default:
          return false;
      }
    },
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.account-checkmark {
  position: absolute;
  right: 5px;
  bottom: 5px;
}
.v-container {
  padding-bottom: 50px;
}
</style>
